module.exports = __webpack_public_path__ + "img/i05.ae5620fd.svg";